import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@rocketlane/ui';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';
import { openIntercomChat, useIsIntercomChatAvailable } from 'components/atoms/intercom-widget/intercom-widget';
import { Modal } from 'components/atoms/modal';
const NITRO_CARE_EMAIL = 'care@rocketlane.com';
const ModalBody = styled.p`
  margin: 0;
`;
const FooterRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: var(--spacing-02);
`;
export const ContactSupportModal = ({ visible, bannerMessage, onClose })=>{
    const { formatMessage } = useIntl();
    const isChatAvailable = useIsIntercomChatAvailable();
    const openChat = ()=>{
        const replyText = formatMessage({
            id: 'nitro.contact_support.modal.chat_prefill'
        }, {
            bannerMessage
        });
        const opened = openIntercomChat(replyText);
        if (opened) {
            onClose();
        }
    };
    const openEmailClient = ()=>{
        window.location.href = `mailto:${NITRO_CARE_EMAIL}`;
    };
    return /*#__PURE__*/ _jsx(Modal, {
        visible: visible,
        title: /*#__PURE__*/ _jsx(FormattedMessage, {
            id: "nitro.contact_support.modal.title"
        }),
        onCancel: onClose,
        zIndex: 1011,
        footer: /*#__PURE__*/ _jsxs(FooterRow, {
            children: [
                /*#__PURE__*/ _jsx(Button, {
                    variant: "secondary",
                    type: "button",
                    onClick: onClose,
                    "data-cy": "contact-support-modal.cancel",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "cancel"
                    })
                }),
                /*#__PURE__*/ _jsx(Button, {
                    variant: isChatAvailable ? 'secondary' : 'primary',
                    type: "button",
                    onClick: openEmailClient,
                    "data-cy": "contact-support-modal.email-cta",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "nitro.contact_support.modal.email_cta"
                    })
                }),
                isChatAvailable ? /*#__PURE__*/ _jsx(Button, {
                    variant: "primary",
                    type: "button",
                    onClick: openChat,
                    "data-cy": "contact-support-modal.chat-cta",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "nitro.contact_support.modal.chat_cta"
                    })
                }) : null
            ]
        }),
        "data-cy": "contact-support-modal",
        children: /*#__PURE__*/ _jsx(ModalBody, {
            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                id: "nitro.contact_support.modal.body"
            })
        })
    });
};
